import Cookies from 'js-cookie';

const TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

export default class TokenService {
  static setToken(token) {
    Cookies.set(TOKEN_KEY, token, { expires: 1 / 24 });
  }

  static getToken() {
    return Cookies.get(TOKEN_KEY);
  }

  static setRefreshToken(token) {
    Cookies.set(REFRESH_TOKEN_KEY, token, { expires: 7 });
  }

  static getRefreshToken() {
    return Cookies.get(REFRESH_TOKEN_KEY);
  }

  static removeTokens() {
    Cookies.remove(TOKEN_KEY);
    Cookies.remove(REFRESH_TOKEN_KEY);
  }
}
